"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useCreateNewChat = require('./hooks/useCreateNewChat'); var _useCreateNewChat2 = _interopRequireDefault(_useCreateNewChat);

var _App = require('web/screens/App');
var _OnboardingDownloadModal = require('web/screens/onboardingShared/OnboardingDownloadModal'); var _OnboardingDownloadModal2 = _interopRequireDefault(_OnboardingDownloadModal);
var _InboxList = require('./InboxList'); var _InboxList2 = _interopRequireDefault(_InboxList);
var _InboxRightSide = require('./InboxRightSide'); var _InboxRightSide2 = _interopRequireDefault(_InboxRightSide);






const InboxScreen = () => {
  const match = _reactrouterdom.useRouteMatch()
  const {
    blobjectKey,
    createdChatType: createdChatTypeURLToken,
  } = match.params

  const {
    createdChatType,
    isNewChatOpen,
    isDraftOpen,
    newChatRun,
    onCreateNewChat,
    onReopenNewChat,
    onCloseCreateNewChat,
    onCreatedChat,
    onDraftChange,
  } = _useCreateNewChat2.default.call(void 0, { createdChatTypeURLToken, blobjectKey })

  return (
    _react2.default.createElement(_App.AppVertical, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      , _react2.default.createElement(_App.NavigationMenu, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , _react2.default.createElement(_InboxList2.default, {
          onCreateNewChat: onCreateNewChat,
          isCreatingNewChat: !!createdChatType,
          isViewingCreateNewChat: isNewChatOpen,
          onCloseCreateNewChat: onCloseCreateNewChat,
          onReopenNewChat: onReopenNewChat,
          isDraftOpen: isDraftOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
        )
      )
      , _react2.default.createElement(_InboxRightSide2.default, {
        blobjectKey: blobjectKey,
        createdChatType: createdChatType,
        isNewChatOpen: isNewChatOpen,
        isDraftOpen: isDraftOpen,
        newChatRun: newChatRun,
        gotoConversation: _actions2.default.gotoBlobject,
        onCloseCreateNewChat: onCloseCreateNewChat,
        onCreatedChat: onCreatedChat,
        onDraftChange: onDraftChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
      )
      , _react2.default.createElement(_OnboardingDownloadModal2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} )
    )
  )
}

exports. default = InboxScreen
